import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-729be590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pm" }
const _hoisted_2 = { class: "pm__elm" }
const _hoisted_3 = { class: "pm__elm-item" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"pm__elm-item pm__elm-item_green\" data-v-729be590>1</div><div class=\"pm__elm-item\" data-v-729be590>2</div><div class=\"pm__elm-item\" data-v-729be590>3</div><div class=\"pm__elm-item\" data-v-729be590>...</div><div class=\"pm__elm-item\" data-v-729be590>10</div>", 5)
const _hoisted_9 = { class: "pm__elm-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconDoubleChevron = _resolveComponent("IconDoubleChevron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconDoubleChevron)
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_IconDoubleChevron, { class: "pm__elm-item-chevron_right" })
      ])
    ])
  ]))
}